// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#container {
  display: flex;
  width: 100%;
  height: 700px;
  position: relative;
}
#container app-user-mangement-menu {
  position: fixed;
  width: 200px;
  height: 700px;
  background: black;
  border-radius: 4px;
  transition: transform 0.3s ease-in-out;
}
#container #content {
  margin-left: 200px;
}

.title {
  margin-left: 10px;
  font-size: 1.1rem;
  font-weight: 600;
  padding-top: 30px;
}

.icon-wrapper {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1000; /* Ensures it appears above other content */
}`, "",{"version":3,"sources":["webpack://./src/app/features/user-management/user-management.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;AACF;AAAE;EACI,eAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EAEA,sCAAA;AACN;AACE;EACE,kBAAA;AACJ;;AAGA;EACE,iBAAA;EACA,iBAAA;EACA,gBAAA;EACA,iBAAA;AAAF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA,EAAA,2CAAA;AADF","sourcesContent":["#container{\n  display: flex;\n  width: 100%;\n  height:700px;\n  position: relative;\n  app-user-mangement-menu{\n      position: fixed;\n      width:200px;\n      height: 700px;\n      background: black;\n      border-radius: 4px;\n      // transform: translateX(-100%);\n      transition: transform 0.3s ease-in-out;\n  }\n  #content{\n    margin-left: 200px;\n  }\n}\n\n.title{\n  margin-left:10px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  padding-top: 30px;\n  \n}\n\n.icon-wrapper {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  z-index: 1000; /* Ensures it appears above other content */\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
